module.exports = __webpack_public_path__ + "media/images/athletes/1684-86f6a784ade4654ef00f32f890d22dbc.png";